<template>
  <div class="styleCard">
    <table class="table table-hover" id="usersTable">
      <thead>
        <tr>
          <th scope="col">
            <div class="input-group">
              <input
                id="userNameFilter"
                type="text"
                class="form-control input-search"
                placeholder="User full name"
                v-on:keyup="searchByName"
              />
            </div>
          </th>
          <th scope="col">
            <div class="input-group">
              <input
                id="userEmailFilter"
                type="text"
                class="form-control input-search"
                placeholder="User email"
                v-on:keyup="searchByEmail"
              />
            </div>
          </th>

          <th
            scope="col"
            v-for="game in dictionaries.activity.users_games_list"
            :key="game.id"
          >
            {{ game.name }}
          </th>
          <th scope="col">Details</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="user in visibleUsers"
          v-bind:visibleUsers="visibleUsers"
          v-bind:currentPage="currentPage"
          :key="user.user.user_id"
        >
          <td v-if="user.user">{{ user.user.first_name }}</td>
          <td v-if="user.user">{{ user.user.email }}</td>
          <td
            v-for="game in dictionaries.activity.users_games_list"
            :key="game.id"
          >
            <label class="checkbox-container">
              <input
                type="checkbox"
                :data-user-id="user.user_id"
                :data-game-id="game.id"
                @change="changeGamePermission($event)"
                :checked="findUserActiveStatus(user.user_id, game.id)"
              />
              <span class="checkmark"></span>
            </label>
          </td>
          <!--          <td v-for="game in games[0]" :key="game.id" v-if="!user.user">
            <label class="checkbox-container">
              <input
                type="checkbox"
                :data-user-id="user.user_id"
                :data-game-id="game.id"
                @change="changeGamePermission($event)"
                :checked="findUserActiveStatus(user.user_id,game.id)"
              />
              <span class="checkmark"></span>
            </label>
          </td>-->
          <td>
            <div
              class="icon-conteiner"
              @mouseenter="popUp(user.user_id)"
              @mouseleave="showPopUp = false"
            >
              <img src="./log.png" :data-user-id="user.user_id" />
            </div>

            <div v-if="showPopUp" class="popup-content ">
              <table class="table-condensed">
                <tbody>
                  <tr>
                    <td v-if="logInfo != undefined">
                      {{ logInfo.updated_at }}
                    </td>
                    <td v-if="logInfo != undefined">
                      {{ logInfo.updated_at }}
                    </td>
                    <td v-if="logInfo != undefined">
                      {{ logInfo.updated_by_user.full_name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <Pagination
      v-bind:users="users"
      v-on:page:update="updatePage"
      v-bind:currentPage="currentPage"
      v-bind:pageSize="pageSize"
    >
    </Pagination></div
></template>

<script>
import apiClientCreator from "../../../../helpers/api/request";
import Pagination from "./Pagination";
import {mapGetters, mapState} from "vuex";

export default {
  name: "UsersTable",
  components: { Pagination },
  data() {
    return {
      games: [],
      users: [],
      logInfo: {},
      currentPage: 0,
      pageSize: 5, // Here need to change to 20 or 30
      visibleUsers: [],
      userRecords: [],
      showPopUp: false
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries"])
  },
  methods: {
    findUserActiveStatus(userId, gameId) {
      const arr = this.userRecords.filter(user => user.user_id === userId);
      return arr.find(game => game.id === gameId) !== undefined
        ? arr.find(game => game.id === gameId).active
        : false;
    },
    popUp(id) {
      this.showPopUp = true;
      this.pop(id);
    },
    pop(id) {
      apiClientCreator(`users/games/perm/user/log/${id}`)
        .get("")
        .then(res => (this.logInfo = res.data[0]));
      // .catch(err => console.log(err));
    },
    searchByName(e) {
      let userName = e.target.value;
      if (userName == "" || userName == null || userName == undefined) {
        apiClientCreator(`users/games/perm/user/all`)
          .get("")
          .then(res => {
            let temUsers = res.data;
            this.userRecords = temUsers;
            let tempUniqUsers = this.getUniqueUser(temUsers, "user_id");
            let uniqUsers = [tempUniqUsers];
            this.users = uniqUsers;
          })
          .then(() => {
            this.updateVisibleUsers();
          });
        //  .catch(err => console.log(err));
      } else {
        apiClientCreator(`users/games/perm/user/name/${userName}`)
          .get("")
          .then(res => {
            let temUsers = res.data;
            this.userRecords = temUsers;

            let tempUniqUsers = this.getUniqueUser(temUsers, "user_id");
            let uniqUsers = [tempUniqUsers];
            this.users = uniqUsers;
          })
          .then(() => {
            this.updateVisibleUsers();
          });
        // .catch(err => console.log(err));
      }
    },
    searchByEmail(e) {
      let userEmail = e.target.value;
      if (userEmail == "" || userEmail == null || userEmail == undefined) {
        apiClientCreator(`users/games/perm/user/all`)
          .get("")
          .then(res => {
            let temUsers = res.data;
            this.userRecords = temUsers;
            let tempUniqUsers = this.getUniqueUser(temUsers, "user_id");
            let uniqUsers = [tempUniqUsers];
            this.users = uniqUsers;
          })
          .then(() => {
            this.updateVisibleUsers();
          });
        //.catch(err => console.log(err));
      } else {
        apiClientCreator(`users/games/perm/user/email/${userEmail}`)
          .get("")
          .then(res => {
            let temUsers = res.data;
            this.userRecords = temUsers;
            let tempUniqUsers = this.getUniqueUser(temUsers, "user_id");
            let uniqUsers = [tempUniqUsers];
            this.users = uniqUsers;
          })
          .then(() => {
            this.updateVisibleUsers();
          });

        // .catch(err => console.log(err));
      }
    },
    changeGamePermission: function(e) {
      let changeGamePermissionData = {
        user_id: e.target.dataset.userId,
        game_id: e.target.dataset.gameId,
        active: e.target.checked ? 1 : 0
      };
      apiClientCreator(`users/games/perm/user/${e.target.dataset.userId}`).put(
        "",
        {
          user_id: changeGamePermissionData.userId,
          game_id: changeGamePermissionData.game_id,
          active: changeGamePermissionData.active
        }
      );
      // .then(res => console.log(res))
      // .catch(err => console.log(err));
    },
    updatePage(pageNumber) {
      this.currentPage = pageNumber;
      this.updateVisibleUsers();
    },
    updateVisibleUsers() {
      this.visibleUsers = this.users[0].slice(
        this.currentPage * this.pageSize,
        this.currentPage * this.pageSize + this.pageSize
      );
      // if we have 0 visible users, go back a page
      if (this.visibleUsers.length == 0 && this.currentPage > 0) {
        this.updatePage(this.currentPage - 1);
      }
    },
    getUniqueUser(arr, comp) {
      // store the comparison  values in array
      const unique = arr
        .map(e => e[comp])
        // store the indexes of the unique objects
        .map((e, i, final) => final.indexOf(e) === i && i)
        // eliminate the false indexes & return unique objects
        .filter(e => arr[e])
        .map(e => arr[e]);

      return unique;
    }
  },

  created() {
    /*
    //Get all games
    apiClientCreator(`users/games`)
      .get("")
      .then(res => (this.games = [...this.games, res.data]));
    //.catch(err => console.log(err));
*/

    //Get all users
    apiClientCreator(`users/games/perm/user/all`)
      .get("")
      .then(res => {
        let temUsers = res.data;
        this.userRecords = temUsers;
        let uniqUsers = this.getUniqueUser(temUsers, "user_id");
        this.users = [...this.users, uniqUsers];
      })
      .then(() => {
        this.updateVisibleUsers();
      });
    // .catch(err => console.log(err));
  }
};
</script>

<style scoped>
/* Customize the label (the container) */
.popup-content {
  padding: 10px;
  position: absolute;
  top: 84px;
  right: 110px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
}
.styleCard {
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  /*overflow: hidden;*/
  height: auto;
  min-width: 300px;
  position: absolute;
  margin: auto;
  top: 90px;
  right: 0;
  left: 0;
  width: 70%;
}
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  border: 1px solid gray;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  background-color: #44a2d2;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.input-search {
  font-family: "Montserrat" !important;
  margin-left: 4px;
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.icon-conteiner {
  cursor: pointer;
}
</style>
